import type { FormControlProps as CoreFormControlProps } from "@mui/material/FormControl";
import CoreFormControl from "@mui/material/FormControl";
import type { ReactNode } from "react";

export type FormControlProps = CoreFormControlProps;
export const FormControl: (props: FormControlProps) => ReactNode =
  CoreFormControl;
